<ms-component-loader *ngIf="showLoader && hasData"></ms-component-loader>
<ng-container *ngIf="hasData && (hideGamingCrossSellByArc$ | async) === false" [ngSwitch]="banner?.type">
    <ms-casino-banner-link
        *ngSwitchCase="'CasinoLink'"
        [model]="banner"
        [position]="position"
        (bannerDataLoaded)="bannerDataLoaded($event)"></ms-casino-banner-link>
    <ms-sport-banner-link
        *ngSwitchCase="'SportLink'"
        [model]="banner"
        [position]="position"
        (bannerDataLoaded)="bannerDataLoaded($event)"></ms-sport-banner-link>
    <ms-banner-jackpot
        *ngSwitchCase="'Jackpot'"
        [model]="banner"
        [position]="position"
        (bannerDataLoaded)="bannerDataLoaded($event)"></ms-banner-jackpot>
    <ms-banner-games *ngSwitchCase="'Games'" [model]="banner" [position]="position" (bannerDataLoaded)="bannerDataLoaded($event)"></ms-banner-games>
    <ms-vyml *ngSwitchCase="'Vyml'" [model]="banner" [position]="position" (bannerDataLoaded)="bannerDataLoaded($event)"></ms-vyml>
    <ms-banner-esport *ngSwitchCase="'Esport'" [model]="banner" (bannerDataLoaded)="bannerDataLoaded($event)"></ms-banner-esport>
</ng-container>
